import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

import { useArtworkTemplateGroupForm } from '@hooks/useArtworkTemplateGroup'
import useProductLines from '@hooks/useProductLines'

interface ArtworkTemplateGroupDetailsProps {
  artworkTemplateGroupFormPayload: ReturnType<typeof useArtworkTemplateGroupForm>,
}

const ArtworkTemplateGroupDetails = (props: ArtworkTemplateGroupDetailsProps) => {
  const {
    artworkTemplateGroupFormPayload: {
      entityState: {
        description,
        name,
        productLineId,
      },
      errors,
      handlers,
    },
  } = props

  const { productLines } = useProductLines({ performHttpRequests: true })

  return (
    <DashboardModule title="Artwork Template Group Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.name} label="* Name">
            <input
              name="name"
              type="text"
              value={name}
              {...handlers}
            />
          </Form.Field>

          <Form.Field errorMessage={errors.description} label="Description">
            <input
              name="description"
              value={description}
              type="text"
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field errorMessage={errors.productLineId} label="Product Line">
            <select name="productLineId" value={productLineId} {...handlers}>
              <option value="">None</option>
              {productLines.map(productLine => (
                <option key={productLine.id} value={productLine.name}>{productLine.displayName}</option>
              ))}
            </select>
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default ArtworkTemplateGroupDetails
